<template>
  <div class="home">
    <v-divider class="primary pt-1"></v-divider>

    <Hero
      :nomeSistema="nomeSistema"
      :textoBanner="textoBanner"
      :linkCadastro="linkCadastro"
      :bannerTopo="bannerTopo"

      :habilitadoCardEntrar="habilitadoCardEntrar"
      :tituloCardEntrar="tituloCardEntrar"
      :textoCardEntrar="textoCardEntrar"
      :botaoCardEntrar="botaoCardEntrar"

      :habilitadoCardPrimeiroAcesso="habilitadoCardPrimeiroAcesso"
      :tituloCardPrimeiroAcesso="tituloCardPrimeiroAcesso"
      :textoCardPrimeiroAcesso="textoCardPrimeiroAcesso"
      :botaoCardPrimeiroAcesso="botaoCardPrimeiroAcesso"

      :habilitadoCardCadastro="habilitadoCardCadastro"
      :tituloCardCadastro="tituloCardCadastro"
      :textoCardCadastro="textoCardCadastro"
      :botaoCardCadastro="botaoCardCadastro"

      :habilitadoCardPasso1="habilitadoCardPasso1"
      :tituloCardPasso1="tituloCardPasso1"
      :textoCardPasso1="textoCardPasso1"

      :habilitadoCardPasso2="habilitadoCardPasso2"
      :tituloCardPasso2="tituloCardPasso2"
      :textoCardPasso2="textoCardPasso2"

      :habilitadoCardPasso3="habilitadoCardPasso3"
      :tituloCardPasso3="tituloCardPasso3"
      :textoCardPasso3="textoCardPasso3"

      :habilitadoCardPasso4="habilitadoCardPasso4"
      :tituloCardPasso4="tituloCardPasso4"
      :textoCardPasso4="textoCardPasso4"

      :canaisAtendimento="canaisAtendimento"
      :habilitadoLinkFaleConosco="habilitadoLinkFaleConosco"

      :habilitadoAutenticacaoPessoaFisica="habilitadoAutenticacaoPessoaFisica"
      :habilitadoAutenticacaoPessoaJuridica="habilitadoAutenticacaoPessoaJuridica"

      :urlCadastroAvulsaPessoaFisica="urlCadastroAvulsaPessoaFisica"
      :urlCadastroAvulsaPessoaJuridica="urlCadastroAvulsaPessoaJuridica"

    />

    <section>
      <v-layout column wrap class="my-12" align-center>
        <v-flex xs12 sm4 class="my-4">
          <div class="text-center">
            <h2 class="display-1">O que é a Nota Fiscal Eletrônica Avulsa?</h2>
            <p class="subheading grey--text mt-6">{{ sobreSistema }}</p>
          </div>
        </v-flex>
        <v-flex xs12 sm4>
          <v-container grid-list-xl>
            <div class="text-center">
              <h2 class="display-1 my-3 font-weight-font-weight-thin">
                Veja como é fácil fazer parte desta inovação
              </h2>
            </div>
            <v-divider></v-divider>
            <v-layout wrap justify-center>
              <v-flex xs12 md3 v-show="habilitadoCardPasso1">
                <v-card>
                  <v-card-title class="title">{{ tituloCardPasso1 }}</v-card-title>
                  <v-card-text>
                    <span class="body-2">{{ textoCardPasso1 }}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md3 v-show="habilitadoCardPasso2">
                <v-card>
                  <v-card-title class="title">{{ tituloCardPasso2 }}</v-card-title>
                  <v-card-text>
                    <span class="body-2">{{ textoCardPasso2 }}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md3 v-show="habilitadoCardPasso3">
                <v-card>
                  <v-card-title class="title">{{ tituloCardPasso3 }}</v-card-title>
                  <v-card-text>
                    <span class="body-2">{{ textoCardPasso3 }}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md3 v-show="habilitadoCardPasso4">
                <v-card>
                  <v-card-title class="title">{{ tituloCardPasso4 }}</v-card-title>
                  <v-card-text>
                    <span class="body-2">{{ textoCardPasso4 }}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>
  </div>
</template>

<script>
import Hero from "@/components/Hero.vue";

export default {
  components: {
    Hero,
  },
  props: {
    bannerTopo: {
      type: String,
    },
    nomeSistema: {
      type: String,
    },
    textoBanner: {
      type: String,
    },
    sobreSistema: {
      type: String,
    },
    linkCadastro: {
      type: String,
    },

    habilitadoCardEntrar: {
      type: Boolean,
    },
    tituloCardEntrar: {
      type: String,
    },
    textoCardEntrar: {
      type: String,
    },
    botaoCardEntrar: {
      type: String,
    },

    habilitadoCardPrimeiroAcesso: {
      type: Boolean,
    },
    tituloCardPrimeiroAcesso: {
      type: String,
    },
    textoCardPrimeiroAcesso: {
      type: String,
    },
    botaoCardPrimeiroAcesso: {
      type: String,
    },

    habilitadoCardCadastro: {
      type: Boolean,
    },
    tituloCardCadastro: {
      type: String,
    },
    textoCardCadastro: {
      type: String,
    },
    botaoCardCadastro: {
      type: String,
    },

    habilitadoCardPasso1: {
      type: Boolean,
    },

    tituloCardPasso1: {
      type: String,
    },
    textoCardPasso1: {
      type: String,
    },

    habilitadoCardPasso2: {
      type: Boolean,
    },

    tituloCardPasso2: {
      type: String,
    },

    textoCardPasso2: {
      type: String,
    },

    habilitadoCardPasso3: {
      type: Boolean,
    },

    tituloCardPasso3: {
      type: String,
    },
    textoCardPasso3: {
      type: String,
    },

    habilitadoCardPasso4: {
      type: Boolean,
    },

    tituloCardPasso4: {
      type: String,
    },
    textoCardPasso4: {
      type: String,
    },

    canaisAtendimento: {
      type: String,
    },

    habilitadoLinkFaleConosco: {
      type: Boolean,
    },

    habilitadoAutenticacaoPessoaFisica: {
      type: Boolean,
    },
    habilitadoAutenticacaoPessoaJuridica: {
      type: Boolean,
    },

    urlCadastroAvulsaPessoaFisica: {
      type: String,
    },
    urlCadastroAvulsaPessoaJuridica: {
      type: String,
    }
  },
  methods: {
    acessarNoticias() {
      window.location.href = "https://www.sjc.sp.gov.br/noticias/";
    },
    acessarEmpreendedor() {
      window.location.href =
        "https://www.business.govt.nz/getting-started/taking-the-first-steps/questions-to-ask-yourself-before-you-start/";
    },
  },
};
</script>
